/**
 * MG Time Tracker Application
 *
 *	ClickTextField.js
 *
 *
 */

// React Imports
import React, { Component } from 'react';
import { matchNode } from '../../utils/dom';

class ClickTextField extends Component {
    constructor (props) {
        super(props);
        this.state = {isEditing: false};
        this.onClickHandler = this.onClickHandler.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    componentDidUpdate (prevProps, prevState) {
        if(!prevState.isEditing && this.state.isEditing) document.addEventListener('click', this.onClickHandler);
        if(prevState.isEditing && !this.state.isEditing) document.removeEventListener('click', this.onClickHandler);
    }

    componentWillUnmount () {
        document.removeEventListener('click', this.onClickHandler);
    }

    onClickHandler (e) {
        let isInside = matchNode(e.target, this.refs.container);
        if(!isInside) this.setState({ isEditing: false });
    }

    onKeyPress (e) {
        if(e.which === 13) this.setState({ isEditing: false });
    }

    _renderTextField (){
        return (
            <input
                className="edit"
                type="text"
                autoFocus={true}
                value={this.props.value}
                onChange={(e) => this.props.onChange(e.target.value)}
                onKeyPress={this.onKeyPress}
                />
        );
    }

    _renderTextArea () {
        return (
            <textarea
                ref="input"
                className="edit"
                name="description"
                rows="4"
                autoFocus={true}
                onKeyPress={this.onKeyPress}
                value={this.props.value}
                onChange={(e) => this.props.onChange(e.target.value)}
            />
        );
    }

    render () {
        let Field;
        if(this.state.isEditing) {
            Field = this.props.type === 'text' ? this._renderTextField() : this._renderTextArea();
        } else {
            Field = <p onClick={() => this.setState({ isEditing: true }) }>{this.props.value}</p>;
        }

        return (
            <div ref="container" className={this.state.isEditing ? "editable editing" : "editable" }>
                {Field}
                {this.props.children}
            </div>
        );
	}
}

export default ClickTextField;



// WEBPACK FOOTER //
// ./app/components/Admin/ClickTextField.jsx